<template>
  <div class="home">
    <div class="htop">
      <div class="htopL">
        <div class="ht1">Prvi online</div>
        <div class="ht2">diskont</div>
        <div class="ht3">namještaja</div>
        <div class="ht4">u Crnoj Gori</div>
      </div>
      <div class="htopR">
        <p><strong>Poručite namještaj jednostavno</strong><br>
        <ul>
          <li>Odaberite artikle</li>
          <li>Pošaljite porudžbu</li>
          <li>Očekujte poziv od našeg operatera<br>
  u periodu <strong>od 08 do 16h</strong><br>
  radi dogovora oko plaćanja i isporuke</li></ul></p><br>
        <p>Ako želite savjet pri odabiru namještaja ili konsultaciju
oko dostupnosti artikla pozovite nas na <strong>067 626 673</strong><br>
Vaš jedinstveni <strong>ID: {{numid}}</strong></p>
      </div>
    </div>
    <div class="hbot">
      <div>
        <img src="../assets/popust.png">Popust za avansno plaćanje
      </div>
      <div>
        <img src="../assets/pouzecem.png">Mogućnost plaćanja pouzećem
      </div>
      <div>
        <img src="../assets/kartice.png">Plaćanje na rate putem platnih kartica
      </div>
      <div>
        <img src="../assets/isporuka.png">Besplatna<br>isporuka
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {
  }
}
</script>

<script>

export default {
  data() {
    return {
      sliderList: [],
      sliderPos: 0,
      sliderIterval: null
    }
  },
  created() {

  },
  methods: {
    isMobile () {
      let check = false;
      ((a) => {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw(n|u)|c55\/|capi|ccwa|cdm|cell|chtm|cldc|cmd|co(mp|nd)|craw|da(it|ll|ng)|dbte|dcs|devi|dica|dmob|do(c|p)o|ds(12|d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(|_)|g1 u|g560|gene|gf5|gmo|go(\.w|od)|gr(ad|un)|haie|hcit|hd(m|p|t)|hei|hi(pt|ta)|hp( i|ip)|hsc|ht(c(| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i(20|go|ma)|i230|iac( ||\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|[a-w])|libw|lynx|m1w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|mcr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|([1-8]|c))|phil|pire|pl(ay|uc)|pn2|po(ck|rt|se)|prox|psio|ptg|qaa|qc(07|12|21|32|60|[2-7]|i)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h|oo|p)|sdk\/|se(c(|0|1)|47|mc|nd|ri)|sgh|shar|sie(|m)|sk0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h|v|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl|tdg|tel(i|m)|tim|tmo|to(pl|sh)|ts(70|m|m3|m5)|tx9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas|your|zeto|zte/i.test(a.substr(0, 4))) {
          check = true
        }
      })(navigator.userAgent || navigator.vendor || window.opera)
      return check
    }
  },
  computed: {
    numid () {
      return this.$store.getters.sId
    }
  }
}
</script>

<style scoped>

.htop{
  width: 70vw;
  display: flex;
  margin: 0px auto;
  font-family: Roboto;
  top: 2vw;
  position: relative;
}

.htopL{
  width: 50%;
  text-align: right;
  padding-right: 4vw;
  border-right: 1px solid #444;
}

.ht1{
  font-size: 3.2vw;
  font-weight: 500;
}

.ht2{
  font-size: 5.5vw;
  font-weight: 900;
  color: #d00;
}

.ht3{
  font-size: 4.4vw;
  font-weight: 900;
}

.ht4{
  line-height: 5vw;
  font-size: 2.4vw;
  font-weight: 600;
}

.htopR{
  width: 50%;
  text-align: left;
  padding-left: 3vw;
}

.htopR *{
  font-size: 1vw;
  line-height: 1.5;
}

.hbot{
  width: 80vw;
  display: flex;
  position: absolute;
  bottom: 5vw;
  left: 55%;
  transform: translateX(-50%);
}

.hbot div{
  font-size: 1.3vw;
  padding:1vw 1vw 0px 6vw;
  position: relative;
  text-align: left;
  width: 20vw;
}

.hbot img{
    height: 5vw;
    position: absolute;
    left: 0px;
    top: 0px;
  }

.home{
  position: absolute;
  background-image: url('../assets/hbg.jpg');
  background-size: cover;
  background-position: center;
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  top: 0px;
  left: 0px;
  padding: 80px 10px 40px;
  z-index: 100;
  transition: background-image 0.5s;
  transition-timing-function: ease-out;
}

@media only screen and (max-width: 600px) {

  .home{
    height: 100%;
    position: relative;
  }

  .htop{
    display: block;
    width: 90vw;
  }

  .htopL{
    text-align: left;
    border: 0px;
    width: 100%;
    padding-left: 2.6vw;
  }

  .ht1{
    line-height: 10vw;
    font-size: 7.2vw;
    font-weight: 500;
  }

  .ht2{
    font-size: 14.5vw;
    font-weight: 900;
    color: #d00;
  }

  .ht3{
    font-size: 12.4vw;
    font-weight: 900;
  }

  .ht4{
    line-height: 14vw;
    font-size: 8vw;
    font-weight: 600;
  }

  .htopR{
    width: 100%;
  }

  .htopR *{
    font-size: 5vw;
  }

  .htopR span{
    font-size: 4vw;
  }

  ul{
    padding-inline-start: 20px;
  }

  .hbot{
    position: relative;
    display: block;
    padding-top: 30px;
  }

  .hbot div{
    font-size: 5vw;
    font-weight: 700;
    padding:2vw 1vw 3px 19vw;
    position: relative;
    text-align: left;
    width: 90%;
    margin: 40px 0px;
  }

  .hbot img{
    height: 17vw;
    position: absolute;
    left: 0px;
    top: 0px;
  }

}
</style>
